import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import Swal from "sweetalert2";
import { FiPlus } from "react-icons/fi";
import GreenButton from "../../ui/GreenButton";


const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #575757;
    overflow: auto;
`;
const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  

  max-width: 98%;   /* limite de largura */
  margin: auto;   /* centraliza */
  padding: 12px;/* leve respiro interno */
`;

export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;

const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;




const Tr = styled.tr`
  text-align: center;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;

const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: none; /* Oculta cabeçalhos no layout de cards */
  }
`;

const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;


const Td3 = styled.td`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 10px 0px;
  align-items: center;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 500px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;





const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Grid = ({ urlApi, listaMateriais, modalEditarMateriais, modalCadastrarMateriais, setAtualizaMateriais, tipoMaterial, showMateriais,
  onVerMateriais }) => {

  //Token da api
  const token = localStorage.getItem('token');



  //----------------------------------------CHAMA o MODAL DE EDITAR USUARIO E ACESSOS--------------------------------------------------///

  const handleEdit = (item) => {
    modalEditarMateriais(item);

  };

  //---------------------------------------FUNÇÂO DELETAR USUARIO---------------------------------------------------//


  //PopUp de confirmação
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Essa confirmação irá apagar todos os lançamentos existentes para esse material?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  // Deleta os usuários
  const handleDelete = async (item) => {
    const userConfirmed = await showPopUp();

    if (!userConfirmed) {
      return;
    }

    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.delete(`${urlApi}controle-reagentes/deletar-material/${item.COD_MATERIAL}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Código deletado com sucesso.");
      setAtualizaMateriais(true)

    } catch (error) {

      toast.error(error);


    }


  };

  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(listaMateriais);
  const [isLoading, setIsLoading] = useState(true);
  const [tipoSelecionado, setTipoSelecionado] = useState('')


  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = listaMateriais.filter((user) => {
        const cod_material = (user.COD_MATERIAL || '').toString().toLowerCase();
        const descricao = (user.DESCRICAO || '').toLowerCase();
        const desc_tipo = (user.DESC_TIPO || '').toLowerCase();
        const desc_subtipo = (user.DESC_SUBTIPO || '').toLowerCase();

        const passaBusca =
          cod_material.includes(term.toLowerCase()) ||
          descricao.includes(term.toLowerCase()) ||
          desc_tipo.includes(term.toLowerCase()) ||
          desc_subtipo.includes(term.toLowerCase())

        // Filtro por tipo material (numérico)
        const passaFiltroTipoMaterial =
          tipoSelecionado === '' ||
          Number(user.TIPO) === parseInt(tipoSelecionado, 10);



        return (
          passaBusca &&
          passaFiltroTipoMaterial
        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }
    setCurrentPage(1);
    setIsLoading(false);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, listaMateriais, tipoSelecionado]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };

  //---------------------------------------MODAL CADASTRAR USUARIOS---------------------------------------------------//
  // Chama o modal de cadastrar usuários
  const handleCadastrarMateriais = () => {
    modalCadastrarMateriais()
  };






  if (!showMateriais) {
    return (
      <Container>
        <h2>Cadastrar:</h2>
        <GreenButton onClick={onVerMateriais} style={{ margin: '50px' }}>
          Ver Materiais cadastrados...
        </GreenButton>
      </Container>
    );
  }
  return (
    <Container>
      <h2>Cadastrar:</h2>

      <Td3>
        <Input
          type="text"
          placeholder="Pesquisar... Ex: código, descrição, tipo ou subtipo"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Select
          value={tipoSelecionado}
          onChange={(e) => setTipoSelecionado(e.target.value)}
        >
          <option value="">Todos os tipos</option>
          {tipoMaterial.map((tipo) => (
            <option key={tipo.COD_TIPO} value={tipo.COD_TIPO}>
              {tipo.DESC_TIPO}
            </option>
          ))}
        </Select>

        <Div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </Div>

        <ActionButton onClick={handleCadastrarMateriais}>
          Novo cadastro
        </ActionButton>
      </Td3>

      {currentItems.length === 0 ? (
        <Tr>
          <Td colSpan={6} style={{ textAlign: 'center', padding: 20, fontSize: 18 }}>
            Não existem materiais cadastrados.
          </Td>
        </Tr>
      ) : (
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th onClick={() => onColumnClick("COD_MATERIAL")} className={getSortClass("COD_MATERIAL")}>
                  Código: {getSortIcon("COD_MATERIAL")}
                </th>
                <th onClick={() => onColumnClick("DESCRICAO")} className={getSortClass("DESCRICAO")}>
                  Descrição: {getSortIcon("DESCRICAO")}
                </th>
                <th onClick={() => onColumnClick("DESC_TIPO")} className={getSortClass("DESC_TIPO")}>
                  Tipo: {getSortIcon("DESC_TIPO")}
                </th>
                <th onClick={() => onColumnClick("DESC_SUBTIPO")} className={getSortClass("DESC_SUBTIPO")}>
                  Subtipo: {getSortIcon("DESC_SUBTIPO")}
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {currentItems.map((item, i) => (
                <tr key={i}>
                  <td>{item.COD_MATERIAL}</td>
                  <td>{item.DESCRICAO}</td>
                  <td>{item.DESC_TIPO}</td>
                  <td>{item.DESC_SUBTIPO}</td>
                  <td>
                    <ActionButton onClick={() => handleEdit(item)}>
                      Editar
                    </ActionButton>
                  </td>
                  <td>
                    <ActionButton onClick={() => handleDelete(item)}>
                      Deletar
                    </ActionButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      )}
    </Container>
  );
};


export default Grid;
